import axios from 'axios'

const state = {
  lista: [],
  textoPesquisa: '',
  situacao: '1',
  registroSelecionadoId: null,
  recarregarLista: false
}

const mutations = {
  SET_LISTA (state, payload) {
    state.lista = payload
  },
  SET_TEXTO_PESQUISA (state, payload) {
    state.textoPesquisa = payload
  },
  SET_SITUACAO (state, payload) {
    state.situacao = payload
  },
  SET_REGISTRO_SELECIONADO_ID (state, payload) {
    state.registroSelecionadoId = payload
  },
  SET_RECARREGAR_LISTA (state, payload) {
    state.recarregarLista = payload
  },
  SET_LIMPAR (state) {
    state.textoPesquisa = ''
    state.situacao = '1'
  }
}

const actions = {
  GET_LISTA: async ({ commit, state }) => {
    try {
      const filtros = {
        textoPesquisa: state.textoPesquisa,
        situacao: state.situacao
      }

      const { data } = await axios.post('/api/protected/tipo/produto/pesquisar', filtros)
      commit('SET_LISTA', data)
      commit('SET_RECARREGAR_LISTA', false)
      return data
    } catch (error) {
      console.error('Erro ao buscar lista de tipos de produto:', error)
      throw error
    }
  }
}

const getters = {
  lista: state => state.lista,
  textoPesquisa: state => state.textoPesquisa,
  situacao: state => state.situacao,
  registroSelecionadoId: state => state.registroSelecionadoId,
  recarregarLista: state => state.recarregarLista
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/tipo-produto-store.js